const _prefix = '@scrollbar/';

export const SET_SCROLLBAR = _prefix + 'SET_SCROLLBAR';
export const SCROLL_TO_TOP = _prefix + 'SCROLL_TO_TOP';
